<app-loading-generico [message]="loadingGenericoMessage" [loadingGenerico]="loadingGenerico" [buttons]="loadingGenericoData.buttons"></app-loading-generico>

<div class="card">
      <h2 class="titulo-card-2">ORIENTAÇÕES IMPORTANTES</h2>
      <h4 class="paragrafo text">Antes do envio de um pedido, atente-se a:</h4>
      <!-- Accordions -->
      <div class="accordion" id="accordion1"
           (click)="abreFechaAccordion('accordion1')"
           (keydown.enter)="abreFechaAccordion('accordion1')"
           [tag]="addTagManagerInteraction('select:accordion:click', 'modelo')">
            <i class="icone fa fa-angle-down float-end c-primary icone-grande" aria-hidden="true"></i>
            <h4 class="titulo-accordion">MODELO</h4>
            <div class="expansive d-none">
                  <p class="paragrafo">TXT - Possibilita através de arquivo texto, a importação dos dados de endereços, departamentos, cargos, usuários e benefícios da empresa ou grupo de empresas.</p>
                  <a [href]="urlManualTxt" class="link-pagina" id="btnDownloadTxt" target="_blank"
                        [tag]="addTagManagerInteraction('select:link:click', 'modelo:download-de-manual-para-arquivo-txt')"><i class="fa fa-download me-2" aria-hidden="true"></i>Download de manual para arquivo TXT.</a><br><br>
                  <p class="paragrafo">XLS - Possibilita através de arquivo Excel (Planilha Eletrônica), a importação dos dados de endereços, departamentos, cargos, usuários e benefícios da empresa.</p>
                  <a (click)='startFileGeneration("xls")' class="link-pagina" id="btnDownloadXls"
                        [tag]="addTagManagerInteraction('select:link:click', 'modelo:download-de-arquivo-xls')"><i class="fa fa-download me-2" aria-hidden="true"></i>Download de arquivo XLS.</a><br><br>
                  <p class="paragrafo">XLSX - Versão mais recente do tipo de arquivo Excel (Planilha Eletrônica), possibilita a importação dos dados de endereços, departamentos, cargos, usuários e benefícios da empresa.</p>
                  <a (click)='startFileGeneration("xlsx")' class="link-pagina" id="btnDownloadXlsx"
                        [tag]="addTagManagerInteraction('select:link:click', 'modelo:download-de-arquivo-xlsx')"><i class="fa fa-download me-2" aria-hidden="true"></i>Download de arquivo XLSX.</a><br><br>
            </div>
      </div>
      <div class="accordion" id="accordion2"
           (click)="abreFechaAccordion('accordion2')"
           (keydown.enter)="abreFechaAccordion('accordion2')"
           [tag]="addTagManagerInteraction('select:accordion:click', 'tamanho-do-arquivo')">
            <i class="icone fa fa-angle-down float-end c-primary icone grande" aria-hidden="true"></i>
            <h4 class="titulo-accordion">TAMANHO DO ARQUIVO</h4>
            <div class="expansive d-none">
                  <p class="paragrafo">O arquivo TXT, XLS ou XLSX deve conter a formatação específica de nosso sistema, caso o tamanho do arquivo seja maior do que o permitido o sistema não permitirá subi-lo. Qualquer dúvida entre em contato.</p>
            </div>
      </div>
      <div class="accordion" id="accordion3"
           (click)="abreFechaAccordion('accordion3')"
           (keydown.enter)="abreFechaAccordion('accordion3')"
           [tag]="addTagManagerInteraction('select:accordion:click', 'formatacao')">
            <i class="icone fa fa-angle-down float-end c-primary icone grande" aria-hidden="true"></i>
            <h4 class="titulo-accordion">FORMATAÇÃO</h4>
            <div class="expansive d-none">
                  <p class="paragrafo">O formato do arquivo deve seguir os arquivos acima disponibilizados, caso esteja diferente o sistema não será capaz de ler esses arquivos.</p>
            </div>
      </div>
      <div class="accordion" id="accordion4"
           (click)="abreFechaAccordion('accordion4')"
           (keydown.enter)="abreFechaAccordion('accordion4')"
           [tag]="addTagManagerInteraction('select:accordion:click', 'extensao')">
            <i class="icone fa fa-angle-down float-end c-primary icone grande" aria-hidden="true"></i>
            <h4 class="titulo-accordion">EXTENSÃO</h4>
            <div class="expansive d-none">
                  <p class="paragrafo">O formato do arquivo deve seguir os arquivos acima disponibilizados, caso esteja diferente o sistema não será capaz de ler esses arquivos.</p>
            </div>
      </div>
      <h3 class="titulo-card-3">ESTÁ TENDO PROBLEMAS?</h3>
      <h4 class="paragrafo">Para mais informações e problemas comuns.</h4>
      <p>Confira nossa sessão 'Posso ajudar?' no canto inferior esquerdo da página.</p>
</div>
